import { render, staticRenderFns } from "./ChartNum.vue?vue&type=template&id=683e06d2&scoped=true&"
import script from "./ChartNum.vue?vue&type=script&lang=js&"
export * from "./ChartNum.vue?vue&type=script&lang=js&"
import style0 from "./ChartNum.vue?vue&type=style&index=0&id=683e06d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683e06d2",
  null
  
)

export default component.exports